import { ControlStatus } from "../../../../../../utils/constants";

/**
 * Filter controls for Top Open Gaps widget
 * Returns top 5 gaps sorted by severity * impacted_included_entities_count
 */
export const filterTopOpenGaps = (controls) => {
  if (!controls || !Array.isArray(controls)) return [];

  // Filter for gaps only
  const gaps = controls.filter(
    (control) => control.status === ControlStatus.GAP
  );
  // Sort by impacted_included_entities_count and then by severity
  const sortedGaps = gaps
    .sort(
      (a, b) =>
        b.impacted_included_entities_count - a.impacted_included_entities_count
    )
    .sort((a, b) => {
      const scoreA = a.severity;
      const scoreB = b.severity;
      return scoreB - scoreA; // Descending order
    })
    .slice(0, 5);

  return sortedGaps.map((control) => ({
    ...control,
    id: control.control_id,
  }));
};

/**
 * Filter controls for Team Tasks widget
 * Returns gaps assigned to team members, sorted by severity
 */
export const filterTeamTasks = (controls) => {
  if (!controls || !Array.isArray(controls)) return [];

  const teamTasks = controls.filter((control) => {
    return (
      control.status === ControlStatus.GAP &&
      control.assignee_email &&
      control.assignee
    );
  });

  // Sort by severity (descending)
  teamTasks.sort((a, b) => b.severity - a.severity);

  return teamTasks.map((control) => ({
    ...control,
    id: control.control_id,
  }));
};

/**
 * Filter controls for My Tasks widget
 * Returns gaps assigned to the current user, sorted by severity
 */
export const filterMyTasks = (controls, currentUserEmail) => {
  if (!controls || !Array.isArray(controls) || !currentUserEmail) return [];

  const myTasks = controls.filter((control) => {
    return (
      control.status === ControlStatus.GAP &&
      control.assignee_email === currentUserEmail
    );
  });

  // Sort by severity (descending)
  myTasks.sort((a, b) => b.severity - a.severity);

  return myTasks.map((control) => ({
    ...control,
    id: control.control_id,
  }));
};

/**
 * Filter controls for Favorite Controls widget
 * Returns controls marked as favorites, sorted by severity * status
 */
export const filterFavoriteControls = (controls) => {
  if (!controls || !Array.isArray(controls)) return [];

  const favoriteControls = controls.filter((control) => control.is_favorite);

  // Sort by severity * status (descending)
  favoriteControls.sort((a, b) => {
    const scoreA = a.severity * a.status;
    const scoreB = b.severity * b.status;
    return scoreB - scoreA;
  });

  return favoriteControls.map((control) => ({
    ...control,
    id: control.control_id,
  }));
};
